import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "./LogoG.jpg";

const firmagts = "/firmagts.png";

const generatePDFBol = (invoice, date, orderNumber) => {
  const doc = new jsPDF();

  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFontSize(10);
  let textWidth =
    (doc.getStringUnitWidth(`DATE: ${date}`) * doc.internal.getFontSize()) /
    doc.internal.scaleFactor;
  let textOffset = (pageWidth - textWidth) / 2;
  doc.text(`DATE: ${date}`, 10, 35);

  doc.setFontSize(24);
  textWidth =
    (doc.getStringUnitWidth("BILL OF LADING") * doc.internal.getFontSize()) /
    doc.internal.scaleFactor;
  textOffset = (pageWidth - textWidth) / 2;
  doc.text("BILL OF LADING", textOffset, 20);

  doc.setFontSize(10);
  doc.text(`ORDER NUMBER: #${orderNumber}`, 10, 40);
  doc.setFontSize(8);
  doc.text("CARRIER INFORMATION", 10, 47);

  doc.addImage(logo, "PNG", pageWidth - 50 - 10, 10, 50, 50);

  // Table Ship From
  autoTable(doc, {
    startY: 50,
    margin: { left: 10 },
    head: [
      [
        {
          content: "SHIP FROM",
          colSpan: 1,
          styles: { halign: "center", valign: "middle", lineWidth: 0.1 },
        },
      ],
    ],
    body: [
      [`Name: ${invoice.nameSF}`],
      [`Address: ${invoice.addressSF}`],
      [`City/State/Zip: ${invoice.cityStateZSF}`],
    ],
    tableWidth: 85,
    theme: "grid",
    styles: { halign: "left", valign: "middle" },
    headStyles: {
      fillColor: [0, 0, 0],
      textColor: [255, 255, 255],
      fontSize: 12,
      fontStyle: "none",
    },
  });

  autoTable(doc, {
    startY: 85,
    margin: { left: 10 },
    head: [
      [
        {
          content: "SHIP TO",
          colSpan: 1,
          styles: { halign: "center", valign: "middle", lineWidth: 0.1 },
        },
      ],
    ],
    body: [
      [`Name: ${invoice.nameST}`],
      [`Address: ${invoice.addressST}`],
      [`City/State/Zip: ${invoice.cityStateZST}`],
    ],
    tableWidth: 85,
    theme: "grid",
    styles: { halign: "left", valign: "middle" },
    headStyles: {
      fillColor: [0, 0, 0],
      textColor: [255, 255, 255],
      fontSize: 12,
      fontStyle: "none",
    },
  });

  // Table Third Party
  autoTable(doc, {
    startY: 85,
    margin: { left: 105 },
    head: [
      [
        {
          content: "THIRD PARTY FREIGHT CHARGES BILL TO",
          colSpan: 1,
          styles: { halign: "center", valign: "middle", lineWidth: 0.1 },
        },
      ],
    ],
    body: [
      [`Name: ${invoice.nameTP}`],
      [`Address: ${invoice.addressTP}`],
      [`City/State/Zip: ${invoice.cityStateZTP}`],
      [`Special Instructions: ${invoice.instructions}`],
    ],
    tableWidth: 85,
    theme: "grid",
    styles: { halign: "left", valign: "middle" },
    headStyles: {
      fillColor: [0, 0, 0],
      textColor: [255, 255, 255],
      fontSize: 12,
      fontStyle: "none",
    },
  });

  // Table BoL
  autoTable(doc, {
    startY: 50,
    margin: { left: 105 },
    body: [
      [`Bill of Lading Number: ${invoice.bolNumber}`],
      [`Carrier Name: ${invoice.carrierName}`],
      [`MC#: ${invoice.trailerNumber}`],
      [`USDOT#: ${invoice.sealNumber}`],
    ],
    tableWidth: 85,
    theme: "grid",
    styles: { halign: "left", valign: "middle" },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontSize: 12,
      fontStyle: "none",
    },
  });

  // Table Notes
  const lastTableFinalYn = doc.previousAutoTable.finalY;
  autoTable(doc, {
    startY: lastTableFinalYn + 65,
    margin: { left: 10 },
    head: [
      [
        {
          content: "NOTES",
          styles: { halign: "center", valign: "middle", lineWidth: 0.1 },
        },
      ],
    ],
    body: [[`${invoice.notes}`]],
    tableWidth: 180,
    theme: "grid",
    styles: { halign: "left", valign: "middle" },
    headStyles: {
      fillColor: [0, 0, 0],
      textColor: [255, 255, 255],
      fontSize: 12,
      fontStyle: "none",
      lineWidth: 0.1,
    },
  });

  // Table Carrier Info
  const lastTableFinalY = doc.previousAutoTable.finalY;
  autoTable(doc, {
    startY: lastTableFinalY + 5,
    margin: { left: 10 },
    head: [
      [
        {
          content: "LOAD INFORMATION",
          colSpan: 3,
          styles: { halign: "center", valign: "middle", lineWidth: 0.1 },
        },
      ],
      [
        { content: "QTY", styles: { halign: "center", valign: "middle" } },
        { content: "WEIGHT", styles: { halign: "center", valign: "middle" } },
        {
          content: "DESCRIPTION",
          styles: { halign: "center", valign: "middle" },
        },
      ],
    ],
    body: invoice.rows.map((row) => [row.qty, row.weight, row.description]),
    tableWidth: 180,
    theme: "grid",
    styles: { halign: "center", valign: "middle" },
    headStyles: {
      fillColor: [0, 0, 0],
      textColor: [255, 255, 255],
      fontSize: 12,
      fontStyle: "none",
      lineWidth: 0.1,
    },
  });

  // Firma esquina inferior derecha
  const pageHeight = doc.internal.pageSize.getHeight();

  const signatureWidth = 85;
  const signatureHeight = 70;

  const signatureX = pageWidth - signatureWidth - 10;
  const signatureY = pageHeight - signatureHeight - 10;

  doc.addImage(
    firmagts,
    "PNG",
    signatureX,
    signatureY,
    signatureWidth,
    signatureHeight
  );

  doc.save(`BoL_${invoice.bolNumber}.pdf`);
};

export default generatePDFBol;
